import React, {useEffect, useState} from 'react'
import Wrapper from '../../Wrapper'
import { PaymentPlanSelectBottomModal } from '../../../../ui/organisms/PaymentPlanSelectBottomModal'

export const Suppliers = () => {

    return (
        <Wrapper>
            <PaymentPlanSelectBottomModal/>
        </Wrapper>
    )
}